<template>
  <v-app-bar color="green" fixed clipped-left dark app id="main-toolbar" :elevation="0">
    <v-app-bar-nav-icon @click.stop="handleDrawerToggle"></v-app-bar-nav-icon>
    <v-spacer></v-spacer>
    <img
      style="height: 25px;"
      :to="{name : 'Dashboard'}"
      v-bind:src="computeLogo"
      height="36"
      alt="Ecotrace"
    />
    <v-spacer></v-spacer>
    <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on">
          <span class="hidden-sm-and-down">{{userName}}</span>

          <v-avatar size="30px">
            <v-icon>fa-user-circle</v-icon>
          </v-avatar>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="(item,index) in items"
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          @click="item.click"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="index"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>{{ item.title }}</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script>
import Vue from 'vue'
import Util from '@/util'
import menu from '@/router/paths'
export default {
  name: 'app-toolbar',
  components: {},
  data: () => ({
    userName: '',
    title: '',
    items: [
      {
        icon: 'account_circle',
        href: '#',
        title: 'Perfil',
        click: e => {
          Vue.router.push({ name: 'Profile' })
        }
      },
      {
        icon: 'fullscreen_exit',
        href: '#',
        title: 'Sair',
        click: e => {
          window.getApp.$emit('APP_LOGOUT')
        }
      }
    ]
  }),
  mounted() {
    const firstName = this.$auth.user().name
      ? this.$auth.user().name.split(' ')[0]
      : ''
    this.userName = firstName
  },
  computed: {
    computeLogo() {
      return '/static/logo-ligth-a.png'
    },
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav
    },
    showTitle() {
      menu.forEach(item => {
        if (item.name === this.$route.name) {
          this.title = item.title
        }
      })
      return this.title
    }
  },
  methods: {
    handleDrawerToggle() {
      window.getApp.$emit('APP_DRAWER_TOGGLED')
    },
    handleFullScreen() {
      Util.toggleFullScreen()
    }
  }
}
</script>

<style scoped lang="css">
#main-toolbar .v-toolbar__extension > .v-toolbar__title {
  margin-left: 0px;
}
</style>

